import { css } from 'styled-components';
import { BreakpointQueryName, ThemedFunctor } from '@doveit/lego';

export const main: ThemedFunctor = ({
  theme,
  $order,
  $addCss,
}) => css`
  ${$addCss && $addCss}
  flex-grow: 1;

  ${$order && `
    ${theme.breakpoints.up(BreakpointQueryName.LG)} {
      order: ${$order};
    }
  `}
`;
